import React, { useState, useEffect } from "react";
import { AppProvider, useAppContext } from "@/AppContext";
import { ReactFlowProvider } from "@xyflow/react";
import PageTop from "@/Pages/Project/PageTop";
import PageSeletor from "@/Pages/Project/Flow/Right/PageSeleltor";
import { useLocation, useParams } from "react-router-dom";
import { tempTasks, tempResult, tempInput } from "../tempConst";
import materialsDB from '@/constants/materialsDB';
import { rebuildFormula } from '@/config/func';
import CalculateTask3DYCZPage from './calculateTask3DYCZPage';
import CalculateTask3LGPage from './calculateTask3LG';
import "./../index.less";
import { getJob } from "@/services/common";
import userInfo from "@/Components/user";
import response0423 from '@/constants/response_0423.json';
import ResultJSON from './resultJSON';

const Component = () => {
  const { state, actions } = useAppContext();
  //   const location = useLocation();
  // 使用 useParams 获取URL中的参数
  const params = useParams<{ k: string; f: string; j: string }>();
  const [activeTab, setActiveTab] = useState("element");
  const [transInput, setTransInput] = useState({});
  const [input, setInput] = useState<any>({});
  const [response, setResponse] = useState<any>({});


  useEffect(() => {
    getJob(params.j, userInfo.access_token).then((r) => {
      if (r.status === 200) {
        setInput({
          name: r.data.name,
          flow_id: r.data.flow_id,
          description: r.data.description,
          inputs: JSON.parse(r.data.input)
        });
        setResponse(JSON.parse(r.data.output.replace(/NaN/g, '0')));
        // console.log('r.data.output', JSON.parse(r.data.output.replace(/NaN/g, '0')));
        // setResponse(response0423.response);
      }
    });
  }, []);

  const transformMaterials = (rawMaterials: any[]) => {
    return rawMaterials.map((material, index) => {
      const m: any = materialsDB.find((item: any) => item.cas === material.cas);
      return {
        cas: material.cas,
        Molecular_formula: rebuildFormula(m.Molecular_formula),
        Name_ZH: m.Name_ZH,
        MW: m.MW,
        index: index,
        molar_frac: material.molar_frac,
      };
    });
  };
  useEffect(() => {
    const transformedMaterials = {
      materials: transformMaterials(
        (tempInput as any)?.inputs?.streams?.filter(
          (item: any) => item?.materials.length > 0,
        )[0].materials,
      ),
    };
    setTransInput(transformedMaterials);
  }, [])

  // Tab 配置
  const tabs = [
    { key: "element", label: "单元操作" },
    { key: "stream", label: "流股" },
    { key: "heat", label: "热交换" },
    { key: "economy", label: "经济效益" },
    { key: "json", label: "完整输入输出" },
  ];


  return (
    <ReactFlowProvider>
      {state.curFlow && state.curProject && state.projectList && input && Object.keys(input).length > 0 &&
        response && Object.keys(response).length > 0 ? (
        <>
          <PageTop
            mainContent={
              <div className="settingSelectorArea">
                <PageSeletor />
              </div>
            }
          />
          <div className="mainContent">
            <div className="mainTask" style={{ width: "95%" }}>
              <div className="tabContainer">
                <div className="tabTitle">{input?.name}：</div>

                {/* Tab 按钮组 */}
                <div className="tabButtonGroup">
                  {tabs.map((tab) => (
                    <div
                      key={tab.key}
                      onClick={() => setActiveTab(tab.key)}
                      className={`tabItem ${activeTab === tab.key ? "tabActive" : "tabInactive"}`}
                    >
                      <span className={`tabText ${activeTab === tab.key ? "tabTextActive" : "tabTextInactive"}`}>
                        {tab.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Tab 内容区域 */}
              <div className="tabContent">
                {!input ? (
                  <div className="loadingText">加载中...或未找到对应任务数据</div>
                ) : (
                  <>
                    {activeTab === "element" && (
                      <CalculateTask3DYCZPage
                        input={input}
                        transInput={transInput}
                        results={response}
                      />
                    )}
                    {activeTab === "stream" && (
                      <div className="sectionContent">
                        <CalculateTask3LGPage input={input} results={response} />
                      </div>
                    )}
                    {activeTab === "heat" && (
                      <div className="sectionContent">
                        <h4 className="sectionTitle">热交换参数</h4>
                      </div>
                    )}
                    {activeTab === "economy" && (
                      <div className="sectionContent">
                        <h4 className="sectionTitle">经济效益参数</h4>
                      </div>
                    )}
                    {activeTab === "json" && (
                      <ResultJSON input={input} results={response} />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      ) : null}
    </ReactFlowProvider>
  );
};

export default Component;